import update from 'immutability-helper';
import { handleActions } from 'redux-actions';
import {
  END_THUMBNAIL_GENERATION,
  START_THUMBNAIL_GENERATION,
} from '../constants/actions';

const initialState = {};

export default handleActions(
  {
    [START_THUMBNAIL_GENERATION]: (state, { payload: id }) =>
      update(state, {
        [id]: {
          $set: {
            timeStamp: String(Date.now()),
            inProgress: true,
          },
        },
      }),
    [END_THUMBNAIL_GENERATION]: (state, { payload: id }) =>
      update(state, {
        [id]: {
          $merge: {
            inProgress: false,
          },
        },
      }),
  },
  initialState,
);
